"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugin_lifecycle_phases_1 = __importDefault(require("../enums/plugin-lifecycle-phases"));
/**
 * @class GraphandPlugin
 * @classdesc Base Plugin class. You can extend this class to create your own plugins
 */
class GraphandPlugin {
    constructor(options) {
        const { constructor } = Object.getPrototypeOf(this);
        this.options = Object.assign({}, constructor.defaultOptions, options);
    }
    install(client) {
        this.client = client;
        this.execute(plugin_lifecycle_phases_1.default.INSTALL);
        return this;
    }
    // constructor(client: GraphandClient, options: Partial<T> = {}) {
    //   const { constructor } = Object.getPrototypeOf(this);
    //
    //   this.client = client;
    //   this.options = Object.assign({}, constructor.defaultOptions, options);
    //
    //   this.execute(PluginLifecyclePhases.INSTALL);
    // }
    onInstall() {
        return;
    }
    onInit() {
        return;
    }
    onUninstall() {
        return;
    }
    execute(phase) {
        if (!this.client) {
            throw new Error(`Please use Plugin.prototype.install(client) before execute`);
        }
        switch (phase) {
            case plugin_lifecycle_phases_1.default.INSTALL:
                return this.onInstall();
            case plugin_lifecycle_phases_1.default.INIT:
                return this.onInit();
            case plugin_lifecycle_phases_1.default.UNINSTALL:
                return this.onUninstall();
            default:
                return;
        }
    }
}
GraphandPlugin.LifecyclePhases = plugin_lifecycle_phases_1.default;
GraphandPlugin.defaultOptions = {};
exports.default = GraphandPlugin;
